/**
 * Clears MSAL session/local storage keys to recover from a stuck
 * `interaction_in_progress` state.
 */
export function clearMsalCache() {
  const sessionKeysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (
      key &&
      (key.includes("msal") ||
        key.includes("authority") ||
        key.includes("interaction") ||
        key.includes("login"))
    ) {
      sessionKeysToRemove.push(key);
    }
  }
  sessionKeysToRemove.forEach((key) => sessionStorage.removeItem(key));

  const localKeysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key &&
      (key.includes("msal") ||
        key.includes("authority") ||
        key.includes("interaction"))
    ) {
      localKeysToRemove.push(key);
    }
  }
  localKeysToRemove.forEach((key) => localStorage.removeItem(key));
}
